import offset from './offset';

/**
 * Adjusts the position of an element to ensure it fits within the viewport.
 *
 * This function checks the position of the given element and adds a class to reverse its position
 * if it overflows the viewport. It handles both left-to-right (LTR) and right-to-left (RTL) layouts.
 *
 * @module smartPosition
 * @param {HTMLElement} el - The element to be positioned.
 * @param {Object} params - Configuration parameters.
 * @param {Object} params.classMap - A map of CSS classes.
 * @param {string} params.classMap.reversed - The CSS class to add when the element needs to be reversed.
 * @param {boolean} [params.rtl=false] - Flag indicating if the layout is right-to-left.
 */
export default function smartPosition(el, params) {
  if (!el || !params || !params.classMap || !params.classMap.reversed) {
    return;
  }

  const elementOffset = offset(el);
  if (!elementOffset || typeof elementOffset.left !== 'number') {
    console.error('Invalid offset value:', elementOffset);
    return;
  }

  const reversedClass = params.classMap.reversed.slice(1);

  if (!params.rtl) {
    if (elementOffset.left + el.offsetWidth > window.innerWidth) {
      el.classList.add(reversedClass);
    }
  } else {
    if (elementOffset.left < 0) {
      el.classList.add(reversedClass);
    }
  }
}
